"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DROPDOWN_MENU_SIGN_IN_EVENT = exports.DROPDOWN_MENU_SIGN_OUT_EVENT = exports.DROPDOWN_MENU_BALANCE_CLICK_EVENT = exports.DROPDOWN_MENU_DISPLAY_EVENT = exports.DROPDOWN_MENU_ITEM_CLICK_EVENT = exports.NOTIFICATIONS_QUERY_INTERVAL = exports.NAVBAR_CLICK_EVENT = void 0;
exports.NAVBAR_CLICK_EVENT = 'Click on Navbar';
exports.NOTIFICATIONS_QUERY_INTERVAL = 60000;
exports.DROPDOWN_MENU_ITEM_CLICK_EVENT = 'Unified Dropdown Menu Item Click';
exports.DROPDOWN_MENU_DISPLAY_EVENT = 'Unified Dropdown Menu Display';
exports.DROPDOWN_MENU_BALANCE_CLICK_EVENT = 'Unified Dropdown Menu Balance Click';
exports.DROPDOWN_MENU_SIGN_OUT_EVENT = 'Unified Dropdown Menu Sign Out';
exports.DROPDOWN_MENU_SIGN_IN_EVENT = 'Unified Dropdown Menu Sign In';
//# sourceMappingURL=constants.js.map